
//	Project: Turnbull Hill

//	[ Custom Javascript ]


$(document).ready(function() {


//---------------------------------------------------------------------------
//	Location Dropdown
//---------------------------------------------------------------------------

$('.js-locations-dropdown-container').appendAround();
$('.js-locations-dropdown-list').appendAround();

$('.js-service-funnel-contact').appendAround();


function locationsDropdown() {
	$('.js-locations-dropdown-toggle').click(function() {
		$('.js-locations-dropdown-panel').slideToggle();
		$('.js-site-search').slideUp();
		$('.js-search-toggle').removeClass('is-active');
	});
}

locationsDropdown();

enquire.register("screen and (min-width:48em)", {
	match : function() {
		$('.js-locations-dropdown-toggle').off('click');
		$('.js-locations-dropdown-panel').css('display',  '');
	},      
								
	unmatch : function() {
		locationsDropdown();
	}
});





//---------------------------------------------------------------------------
//  Search
//---------------------------------------------------------------------------

$('.js-search-toggle').click(function() {
	$('.js-search-toggle').toggleClass('is-active');
	$('.js-site-search').slideToggle();

	$('.js-locations-dropdown-panel').slideUp();
})





//---------------------------------------------------------------------------
//	Banners & Carousels
//---------------------------------------------------------------------------

// feature banner

$('.js-feature-banner').owlCarousel({
	autoplay: true,
	items: 1,
	loop: true,
	animateOut: 'fadeOut',
	dots: true,
	dotsContainer: '.js-feature-banner-nav',
	autoHeight: true
});


$('.js-owl-dot').click(function () {
	$('.js-feature-banner').trigger('to.owl.carousel', [$(this).index(), 300]);
});


// experts carousel

$('.js-experts-carousel').owlCarousel({
	autoplay: true,
	autoWidth: true,
	dots: false,
	items:2,
	loop:true,
	margin: 20,
	nav: true,
	navText: ['<svg class="owl-nav__arrow o-carousel-arrow o-carousel-arrow--prev" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 24.74 8.77"><use xlink:href="#icon-arrow" /></svg>','<svg class="owl-nav__arrow o-carousel-arrow o-carousel-arrow--next" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 24.74 8.77"><use xlink:href="#icon-arrow" /></svg>']
});


// media carousel

$('.js-media-carousel').owlCarousel({
	autoHeight: false,
	autoplay: false,
	margin: 40,
	items: 1,
	loop: true,
	dots: false,
	nav: true,
	navText: ['<svg class="owl-nav__arrow o-carousel-arrow--alt o-carousel-arrow--prev" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 24.74 8.77"><use xlink:href="#icon-angle-right" /></svg>','<svg class="owl-nav__arrow o-carousel-arrow--alt o-carousel-arrow--next" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 24.74 8.77"><use xlink:href="#icon-angle-right" /></svg>'],
	responsive : {
		768 : {
			items: 2,
		},
		1024 : {
			items: 3,
		},
	}
});


// team carousel

$('.js-team-carousel').owlCarousel({
	autoHeight: false,
	autoplay: false,
	margin: 40,
	items: 1,
	loop: false,
	dots: false,
	nav: true,
	navText: ['<svg class="owl-nav__arrow o-carousel-arrow--alt o-carousel-arrow--prev" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 24.74 8.77"><use xlink:href="#icon-angle-right" /></svg>','<svg class="owl-nav__arrow o-carousel-arrow--alt o-carousel-arrow--next" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 24.74 8.77"><use xlink:href="#icon-angle-right" /></svg>'],
	responsive : {
		530 : {
			items: 2,
		},
		768 : {
			items: 3,
		},
		992 : {
			items: 4,
		},
	}
});


// testimonial carousel

$('.js-testimonial-carousel').owlCarousel({
	autoHeight: false,
	autoplay: true,
	dots: true,
	items: 1,
	loop:true,
	nav: true,
	autoplayTimeout: 12000,
	navText: ['<svg class="owl-nav__arrow o-carousel-arrow--alt o-carousel-arrow--prev" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 24.74 8.77"><use xlink:href="#icon-angle-right" /></svg>','<svg class="owl-nav__arrow o-carousel-arrow--alt o-carousel-arrow--next" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 24.74 8.77"><use xlink:href="#icon-angle-right" /></svg>']
});


// events carousel

$('.js-event-carousel').owlCarousel({
	autoHeight: true,
	autoplay: true,
	dots: true,
	items: 4,
	loop:true,
	nav: false,
	navText: ['<svg class="owl-nav__arrow o-carousel-arrow--alt o-carousel-arrow--prev" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 24.74 8.77"><use xlink:href="#icon-angle-right" /></svg>','<svg class="owl-nav__arrow o-carousel-arrow--alt o-carousel-arrow--next" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 24.74 8.77"><use xlink:href="#icon-angle-right" /></svg>'],
	responsive: {
		0 : {
			items: 1
		},
		660 : {
			items: 2,
			margin: 20
		},
		1000 : {
			items: 3,
			margin: 20
		},
		1360 : {
			items: 4,
			margin: 20,
			autoplay: false
		}
	}
});




//---------------------------------------------------------------------------
//	Toggle Reveal
//---------------------------------------------------------------------------

$('.js-intro-reveal-button').click(function() {
	$('.js-intro-reveal-content').slideToggle();
	$(this).hide();
});

$( '.js-blog-popular-reveal-button' ).on( 'click', function() {
	$( '.js-blog-popular-reveal-content' ).slideToggle();
	$( this ).hide();
} );



//---------------------------------------------------------------------------
//	Service Funnels
//---------------------------------------------------------------------------

$('.js-service-toggle-button').click(function(){
	$(this).toggleClass('is-active');

	var set = $(this).data('set');

	$('.js-service-cards[data-set="' + set + '"]').slideToggle();
});

$('.js-service-close-btn').click(function(){
	var set = $(this).data('set');

	$('.js-service-cards[data-set="' + set + '"]').slideUp();
	$('.js-service-toggle-button[data-set="' + set + '"]').removeClass('is-active');
});





//---------------------------------------------------------------------------
//	Footer
//---------------------------------------------------------------------------

footerAccordions();

enquire.register("screen and (min-width:43.75em)", {
	match : function() {
		$('.js-footer-toggle').off('click').removeClass('is-active');
	},      
								
	unmatch : function() {
		footerAccordions();
	},
});


function footerAccordions() {
	$('.js-footer-toggle').click(function(){
		$(this).toggleClass('is-active').next('.js-footer-toggle-content').slideToggle();
	});
}


//---------------------------------------------------------------------------
//	Accordions
//---------------------------------------------------------------------------

accordions();

function accordions() {
    $('.js-accordion-toggle').click(function(){
        var $this = $(this);
        var $parent = $this.parent().parent();
        var $content = $this.next('.js-accordion-toggle-content');
        
        $('.js-accordion-toggle', $parent).not($this).removeClass('is-expanded').next('.js-accordion-toggle-content').slideUp();
        
        $this.toggleClass('is-expanded');
        $content.slideToggle();
    });
}






//---------------------------------------------------------------------------
//	Tabs
//---------------------------------------------------------------------------

function TabWidget (el, selectedIndex) {

	if (!el) {
		return;
	}

	this.el = el;
	this.tabTriggers = this.el.getElementsByClassName('js-tab-trigger');
	this.tabPanels = this.el.getElementsByClassName('js-tab-panel');

	if (this.tabTriggers.length === 0 || this.tabTriggers.length !== this.tabPanels.length) {
		return;
	}

	this._init(selectedIndex);
}

TabWidget.prototype._init = function (selectedIndex) {

	this.tabTriggersLength = this.tabTriggers.length;
	this.selectedTab = 0;
	this.prevSelectedTab = null;
	this.clickListener = this._clickEvent.bind(this);
	this.keydownListener = this._keydownEvent.bind(this);
	this.keys = {
		prev: 37,
		next: 39
	};

	for (var i = 0; i < this.tabTriggersLength; i++) {
		this.tabTriggers[i].index = i;
		this.tabTriggers[i].addEventListener('click', this.clickListener, false);
		this.tabTriggers[i].addEventListener('keydown', this.keydownListener, false);

		if (this.tabTriggers[i].classList.contains('is-selected')) {
			this.selectedTab = i;
		}
	}

	if (!isNaN(selectedIndex)) {
		this.selectedTab = selectedIndex < this.tabTriggersLength ? selectedIndex : this.tabTriggersLength - 1;
	}

	this.selectTab(this.selectedTab);
	this.el.classList.add('is-initialized');
};

TabWidget.prototype._clickEvent = function (e) {

	e.preventDefault();

	if (e.target.index === this.selectedTab) {
		return;
	}

	this.selectTab(e.target.index, true);
};

TabWidget.prototype._keydownEvent = function (e) {

	var targetIndex;

	if (e.keyCode === this.keys.prev || e.keyCode === this.keys.next) {
		e.preventDefault();
	}
	else {
		return;
	}

	if (e.keyCode === this.keys.prev && e.target.index > 0) {
		targetIndex = e.target.index - 1;
	}
	else if (e.keyCode === this.keys.next && e.target.index < this.tabTriggersLength - 1) {
		targetIndex = e.target.index + 1;
	}
	else {
		return;
	}

	this.selectTab(targetIndex, true);
};

TabWidget.prototype._show = function (index, userInvoked) {

	this.tabTriggers[index].classList.add('is-selected');
	this.tabTriggers[index].setAttribute('aria-selected', true);
	this.tabTriggers[index].setAttribute('tabindex', 0);

	this.tabPanels[index].classList.remove('is-hidden');
	this.tabPanels[index].setAttribute('aria-hidden', false);
	this.tabPanels[index].setAttribute('tabindex', 0);

	if (userInvoked) {
		this.tabTriggers[index].focus();
	}
};

TabWidget.prototype._hide = function (index) {

	this.tabTriggers[index].classList.remove('is-selected');
	this.tabTriggers[index].setAttribute('aria-selected', false);
	this.tabTriggers[index].setAttribute('tabindex', -1);

	this.tabPanels[index].classList.add('is-hidden');
	this.tabPanels[index].setAttribute('aria-hidden', true);
	this.tabPanels[index].setAttribute('tabindex', -1);
};

TabWidget.prototype.selectTab = function (index, userInvoked) {

	if (this.prevSelectedTab === null) {
		for (var i = 0; i < this.tabTriggersLength; i++) {
			if (i !== index) {
				this._hide(i);
			}
		}
	}
	else {
		this._hide(this.selectedTab);
	}

	this.prevSelectedTab = this.selectedTab;
	this.selectedTab = index;

	this._show(this.selectedTab, userInvoked);
};

TabWidget.prototype.destroy = function () {

	for (var i = 0; i < this.tabTriggersLength; i++) {
		this.tabTriggers[i].classList.remove('is-selected');
		this.tabTriggers[i].removeAttribute('aria-selected');
		this.tabTriggers[i].removeAttribute('tabindex');

		this.tabPanels[i].classList.remove('is-hidden');
		this.tabPanels[i].removeAttribute('aria-hidden');
		this.tabPanels[i].removeAttribute('tabindex');

		this.tabTriggers[i].removeEventListener('click', this.clickListener, false);
		this.tabTriggers[i].removeEventListener('keydown', this.keydownListener, false);

		delete this.tabTriggers[i].index;
	}

	this.el.classList.remove('is-initialized');
};

new TabWidget(document.getElementsByClassName('js-tabs')[0]);






//---------------------------------------------------------------------------
//	Fancybox
//---------------------------------------------------------------------------

// keep aspect ratio

$('[data-fancybox="video"]').fancybox({
  afterLoad : function( instance, current ) {

	 // Remove scrollbars and change background
	current.$content.css({
			overflow   : 'visible',
	  background : '#000'
		});
				
  },
  onUpdate : function( instance, current ) {
	var width,
		height,
		ratio = 16 / 9,
		video = current.$content;
	
	if ( video ) {
	  video.hide();

	  width  = current.$slide.width();
	  height = current.$slide.height() - 100;
	  
	  if ( height * ratio > width ) {
		height = width / ratio;
	  } else {
		width = height * ratio;
	  }

	  video.css({
		width  : width,
		height : height
	  }).show();

	}
  }
});





//---------------------------------------------------------------------------
//	Push Menu
//---------------------------------------------------------------------------

$('.js-menu-toggle').click(function() {
	$('.js-menu-toggle').toggleClass('is-active');
	$('body').toggleClass('is-pushed');
	$('.js-push-nav').toggleClass('is-pushed');

	if($(this).hasClass('is-active')) {
		$('html, body').animate({
			  scrollTop: '0px'
		}, 1000);
	}

	// if($(this).hasClass('is-active')) {
	// 	$('.js-push-nav').animate({
	// 		  scrollTop: '0px'
	// 	}, 1000);
	// }
});

$('.js-push-menu-toggle').click(function(event) {
	event.preventDefault();
	$(this).parent().toggleClass('is-active');
	$(this).siblings('.push-menu__dropdown').slideToggle();
});





//---------------------------------------------------------------------------
//	Smooth Scrolling
//---------------------------------------------------------------------------

// https://css-tricks.com/snippets/jquery/smooth-scrolling/

// Select all links with hashes
$('a[href*="#"]')
  // Remove links that don't actually link to anything
  .not('[href="#"]')
  .not('[href="#0"]')
  .not('.js-accordion-trigger')
  .not('.js-tab-trigger')
  .click(function(event) {
	// On-page links
	if (
	  location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') 
	  && 
	  location.hostname == this.hostname
	) {
	  // Figure out element to scroll to
	  var target = $(this.hash);
	  target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
	  // Does a scroll target exist?
	  if (target.length) {
		// Only prevent default if animation is actually gonna happen
		event.preventDefault();
		$('html, body').animate({
		  scrollTop: target.offset().top
		}, 1000, function() {
		  // Callback after animation
		  // Must change focus!
		  var $target = $(target);
		  $target.focus();
		  if ($target.is(":focus")) { // Checking if the target was focused
			return false;
		  } else {
			$target.attr('tabindex','-1'); // Adding tabindex for elements not focusable
			$target.focus(); // Set focus again
		  };
		});
	  }
	}
  });





//---------------------------------------------------------------------------
//	Quicklink Toggle
//---------------------------------------------------------------------------

$('.js-quicklinks-toggle').click(function() {
	$(this).toggleClass('is-active');
	$(this).next('.js-quicklinks').slideToggle();
});





//---------------------------------------------------------------------------
//	Masthead Shadow
//---------------------------------------------------------------------------

$(window).scroll(function() {    
    var scroll = $(window).scrollTop();

     //>=, not <=
    if (scroll >= 500) {
        //clearHeader, not clearheader - caps H
        $(".masthead").addClass("is-scrolling");
    } else {
    	$(".masthead").removeClass("is-scrolling");
    }
});

//---------------------------------------------------------------------------
//	Accessible Accodion
//---------------------------------------------------------------------------

function AccordionWidget (el, selectedIndex) {
	if (!el) {
		return;
	}

	this.el = el;

	this.accordionTriggers = this.el.getElementsByClassName('js-accordion-trigger');
	this.accordionPanels = this.el.getElementsByClassName('js-accordion-panel');

	if (this.accordionTriggers.length === 0 || this.accordionTriggers.length !== this.accordionPanels.length) {
		return;
	}

	this._init(selectedIndex);
}

AccordionWidget.prototype._init = function (selectedIndex) {
	this.accordionTriggersLength = this.accordionTriggers.length;
	this.expandedAccordions = new Array(this.accordionTriggersLength);
	this.multiSelectable = this.el.hasAttribute('aria-multiselectable');
	this.clickListener = this._clickEvent.bind(this);
	this.keydownListener = this._keydownEvent.bind(this);
	this.focusListener = this._focusEvent.bind(this);
	this.keys = {
		prev: 38,
		next: 40,
		space: 32
	};

	var initialSelectedIndex;

	for (var i = 0; i < this.accordionTriggersLength; i++) {
		this.accordionTriggers[i].index = i;
		this.accordionTriggers[i].addEventListener('click', this.clickListener, false);
		this.accordionTriggers[i].addEventListener('keydown', this.keydownListener, false);
		this.accordionTriggers[i].addEventListener('focus', this.focusListener, false);

		if (this.accordionTriggers[i].classList.contains('is-selected')) {
			this.expandedAccordions[i] = true;
		}
	}

	if (!isNaN(selectedIndex)) {
		initialSelectedIndex = selectedIndex < this.accordionTriggersLength ? selectedIndex : this.accordionTriggersLength - 1;
		this.expandedAccordions = new Array(this.accordionTriggersLength);
		this.expandedAccordions[initialSelectedIndex] = true;
	}
	else {
		initialSelectedIndex = this.expandedAccordions.lastIndexOf(true);

		if (!this.multiSelectable) {
			this.expandedAccordions = new Array(this.accordionTriggersLength);
			this.expandedAccordions[initialSelectedIndex] = true;
		}
	}

	this.setSelected(initialSelectedIndex);
	this.setExpanded();
	this.el.classList.add('is-initialized');
};

AccordionWidget.prototype._clickEvent = function (e) {
	e.preventDefault();

	this.setSelected(e.target.index, true);
	this.setExpanded(e.target.index, true);
};

AccordionWidget.prototype._keydownEvent = function (e) {
	var targetIndex;

	switch (e.keyCode) {
		case this.keys.space:
		case this.keys.prev:
		case this.keys.next:
			e.preventDefault();
			break;
		default:
			return;
	}

	if (e.keyCode === this.keys.space) {
		this.setExpanded(e.target.index, true);

		return;
	}
	else if (e.keyCode === this.keys.prev && e.target.index > 0) {
		targetIndex = e.target.index - 1;
	}
	else if (e.keyCode === this.keys.next && e.target.index < this.accordionTriggersLength - 1) {
		targetIndex = e.target.index + 1;
	}
	else {
		return;
	}

	this.setSelected(targetIndex, true);
};

AccordionWidget.prototype._focusEvent = function () {
	if (this.accordionTriggersLength === 1) {
		this.setSelected(0);
	}

	return;
};

AccordionWidget.prototype.setSelected = function (index, userInvoked) {
	if (index === -1) {
		this.accordionTriggers[0].setAttribute('tabindex', 0);

		return;
	}

	for (var i = 0; i < this.accordionTriggersLength; i++) {
		if (i === index) {
			this.accordionTriggers[i].classList.add('is-selected');
			this.accordionTriggers[i].setAttribute('aria-selected', true);
			this.accordionTriggers[i].setAttribute('tabindex', 0);

			if (userInvoked) {
				this.accordionTriggers[i].focus();
			}
		}
		else {
			this.accordionTriggers[i].classList.remove('is-selected');
			this.accordionTriggers[i].setAttribute('aria-selected', false);
			this.accordionTriggers[i].setAttribute('tabindex', -1);
		}
	}
};

AccordionWidget.prototype.setExpanded = function (index, userInvoked) {
	var i;

	if (userInvoked) {
		if (this.multiSelectable) {
			this.expandedAccordions[index] = !this.expandedAccordions[index];
		}
		else {
			for (i = 0; i < this.accordionTriggersLength; i++) {
				if (i === index) {
					this.expandedAccordions[i] = !this.expandedAccordions[i];
				}
				else {
					this.expandedAccordions[i] = false;
				}
			}
		}
	}

	for (i = 0; i < this.accordionTriggersLength; i++) {
		if (this.expandedAccordions[i]) {
			this.accordionTriggers[i].setAttribute('aria-expanded', true);
			this.accordionTriggers[i].classList.add('is-expanded');

			this.accordionPanels[i].setAttribute('aria-hidden', false);
			this.accordionPanels[i].classList.remove('is-hidden');
			this.accordionPanels[i].setAttribute('tabindex', 0);
		}
		else {
			this.accordionTriggers[i].setAttribute('aria-expanded', false);
			this.accordionTriggers[i].classList.remove('is-expanded');

			this.accordionPanels[i].setAttribute('aria-hidden', true);
			this.accordionPanels[i].classList.add('is-hidden');
			this.accordionPanels[i].setAttribute('tabindex', -1);
		}
	}
};

AccordionWidget.prototype.destroy = function () {
	this.el.classList.remove('is-initialized');

	for (var i = 0; i < this.accordionTriggersLength; i++) {
		this.accordionTriggers[i].removeAttribute('aria-expanded');
		this.accordionTriggers[i].removeAttribute('aria-selected');
		this.accordionTriggers[i].classList.remove('is-expanded');

		this.accordionPanels[i].removeAttribute('aria-hidden');
		this.accordionPanels[i].classList.remove('is-hidden');
		this.accordionPanels[i].removeAttribute('tabindex');

		this.accordionTriggers[i].removeEventListener('click', this.clickListener, false);
		this.accordionTriggers[i].removeEventListener('keydown', this.keydownListener, false);
		this.accordionTriggers[i].removeEventListener('focus', this.focusListener, false);

		delete this.accordionTriggers[i].index;
	}
};

new AccordionWidget(document.getElementsByClassName('js-accordion')[0]);





//---------------------------------------------------------------------------
//	Forms	
//---------------------------------------------------------------------------

// scroll user to valiation / success message

if($('.js-contact-form_wrapper').hasClass('gform_validation_error') == true || $('.js-contact-form').hasClass('gform_confirmation_wrapper') == true) {
	console.log('errors');

	var target = $('.js-contact-block');

	$('html, body').animate({
		  scrollTop: target.offset().top
		}, 1000);
}

if($('.js-event-form_wrapper').hasClass('gform_validation_error') == true || $('.js-event-form').hasClass('gform_confirmation_wrapper') == true) {
	console.log('errors');

	var target = $('.js-event-register');

	$('html, body').animate({
		  scrollTop: target.offset().top
		}, 1000);
}


// Get Help form - expanding

$('.js-expanding-input').find('input').on('click', function(event) {
	$('.js-expanding-form_wrapper').addClass('is-expanded');
});





//---------------------------------------------------------------------------
//	Notification Bar
//---------------------------------------------------------------------------
	notificationBar();

function notificationBar() {
	var notificationHeight = $('#wpfront-notification-bar').height();
	console.log(notificationHeight);

	if ($('#wpfront-notification-bar').length != '') {
		$('.js-masthead-top-row').css('top', notificationHeight + 'px');
		$('.js-locations-dropdown-panel').css('top', notificationHeight + 54 + 'px');
	}
}


$( window ).resize(function() {
	notificationBar();
});





//---------------------------------------------------------------------------
//	Subscribe Form
//---------------------------------------------------------------------------

var $subscribeForm = $( '.js-subscribe-form' );
var subscribeFormActiveClass = 'subscribe-block__form--expanded';

// Expand subscribe form on form click
$subscribeForm.on( 'click', function() {
	if ( $subscribeForm.hasClass( subscribeFormActiveClass ) === false ) {
		$subscribeForm.addClass( subscribeFormActiveClass );
	}
} );

// Compress subscribe form when clicking outside form
$( document ).on( 'click', function( event ) {
	if ( $subscribeForm.length && $subscribeForm.hasClass( subscribeFormActiveClass ) ) {
		if ( !$( event.target ).closest( $subscribeForm ).length ) {
			$subscribeForm.removeClass( subscribeFormActiveClass );
		}
	}
} );

// // End $(document).ready();
});
